import { mapPlotDef } from "helpers/config/dashboards/global/map"

import {
  bendingPlotDef,
  buildSegmentBendingPlotDef,
  buildSegmentTorsionPlotDef,
  devicesFrontTiltPlotDef,
  devicesInclinationInTowerPlotDef,
  devicesRightTiltPlotDef,
  devicesTiltMagnitudePlotDef,
  lastWServicePrecipitationPlotDef,
  lastWServiceRelativeHumidityPlotDef,
  lastWServiceTemperaturePlotDef,
  lastWServiceWindDirectionPlotDef,
  lastWServiceWindGustPlotDef,
  lastWServiceWindSpeedPlotDef,
  torsionPlotDef,
  towerGlobalLeanPlotDef,
  wServicePrecipitationPlotDef,
  wServiceRelativeHumidityPlotDef,
  wServiceTemperaturePlotDef,
  wServiceWindDirectionPlotDef,
  wServiceWindGustPlotDef,
  wServiceWindSpeedPlotDef,
} from "./defs"

// ─── Legacy (tower_health disabled) ──────────────────────────────────────────

export const getTowerInfoTabPlotDefs = () => [
  mapPlotDef,
  devicesInclinationInTowerPlotDef,
  torsionPlotDef,
  bendingPlotDef,
  wServiceWindSpeedPlotDef,
  lastWServiceWindSpeedPlotDef,
  wServiceWindGustPlotDef,
  lastWServiceWindGustPlotDef,
  wServiceWindDirectionPlotDef,
  lastWServiceWindDirectionPlotDef,
  wServiceTemperaturePlotDef,
  lastWServiceTemperaturePlotDef,
  wServiceRelativeHumidityPlotDef,
  lastWServiceRelativeHumidityPlotDef,
  wServicePrecipitationPlotDef,
  lastWServicePrecipitationPlotDef,
]

export const legacyTowerInfoTabPlotDefs = getTowerInfoTabPlotDefs()

// ─── Tower health layout (tower_health enabled) ───────────────────────────────

export const towerTabPlotDefs = [mapPlotDef, towerGlobalLeanPlotDef]

export const getTowerSegmentsTabPlotDefs = (segments: string[]) => [
  buildSegmentBendingPlotDef("longitudinal", segments),
  buildSegmentBendingPlotDef("lateral", segments),
  buildSegmentBendingPlotDef("magnitude", segments),
  buildSegmentTorsionPlotDef(segments),
]

export const getTowerDevicesTabPlotDefs = () => [
  devicesFrontTiltPlotDef,
  devicesRightTiltPlotDef,
  devicesTiltMagnitudePlotDef,
]

export const getTowerAmbientTabPlotDefs = () => [
  wServiceWindSpeedPlotDef,
  lastWServiceWindSpeedPlotDef,
  wServiceWindGustPlotDef,
  lastWServiceWindGustPlotDef,
  wServiceWindDirectionPlotDef,
  lastWServiceWindDirectionPlotDef,
  wServiceTemperaturePlotDef,
  lastWServiceTemperaturePlotDef,
  wServiceRelativeHumidityPlotDef,
  lastWServiceRelativeHumidityPlotDef,
  wServicePrecipitationPlotDef,
  lastWServicePrecipitationPlotDef,
]
